import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface PendingInvoice {
  id: string;
  job_id: string;
  stripe_invoice_id: string;
  stripe_invoice_number: string | null;
  hosted_invoice_url: string | null;
  pdf_url: string | null;
  amount_due_cents: number;
  status: string;
  due_date: string | null;
  created_at: string;
  payment_context: string | null;
}

export function useJobPendingInvoice(jobId: string | undefined) {
  return useQuery({
    queryKey: ['job-pending-invoice', jobId],
    queryFn: async (): Promise<PendingInvoice | null> => {
      if (!jobId) return null;
      
      const { data, error } = await supabase
        .from('stripe_invoices')
        .select('id, job_id, stripe_invoice_id, stripe_invoice_number, hosted_invoice_url, pdf_url, amount_due_cents, status, due_date, created_at, payment_context')
        .eq('job_id', jobId)
        .in('status', ['open', 'draft', 'payment_failed'])
        .order('created_at', { ascending: false })
        .limit(1)
        .maybeSingle();
      
      if (error) throw error;
      return data;
    },
    enabled: !!jobId,
  });
}
